<template>
  <v-card flat :loading="loading">
    <v-card-title class="pt-4 pa-0 subtitle-1">
      <v-icon>mdi-calendar</v-icon>Disponibilité
    </v-card-title>
    <v-chip-group
      column
      mobile-break-point="0"
      v-model="value"
      multiple
      active-class="green white--text"
    >
      <v-tooltip bottom>
        <template #activator="data">
          <v-chip class="ma-1" label v-on="data.on">L</v-chip>
        </template>
        Lundi
      </v-tooltip>

      <v-tooltip bottom>
        <template #activator="data">
          <v-chip class="ma-1" label v-on="data.on">M</v-chip>
        </template>
        Mardi
      </v-tooltip>

      <v-tooltip bottom>
        <template #activator="data">
          <v-chip class="ma-1" label v-on="data.on">M</v-chip>
        </template>
        Mercredi
      </v-tooltip>

      <v-tooltip bottom>
        <template #activator="data">
          <v-chip class="ma-1" label v-on="data.on">J</v-chip>
        </template>Jeudi
      </v-tooltip>

      <v-tooltip bottom>
        <template #activator="data">
          <v-chip class="ma-1" label v-on="data.on">V</v-chip>
        </template>
        Vendredi
      </v-tooltip>

      <v-tooltip bottom>
        <template #activator="data">
          <v-chip class="ma-1" label v-on="data.on">S</v-chip>
        </template>
        Samedi
      </v-tooltip>

      <v-tooltip bottom>
        <template #activator="data">
          <v-chip class="ma-1" label v-on="data.on">D</v-chip>
        </template>
        Dimanche
      </v-tooltip>
      <v-btn v-show="show" class="ml-3" color="green" outlined @click="save">Save</v-btn>
    </v-chip-group>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data () {
    return {
      days: [],
      show: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'user',
      loading: 'loading',
      success: 'success'
    }),
    value: {
      get () {
        if (this.days.length == 0) this.days = this.user.coach.disponibility
        return this.user.coach.disponibility
      },
      set (newValue) {
        this.user.coach.disponibility = newValue
        // console.log(this.user.coach.disponibility);
        // console.log(this.value);
        // console.log(newValue);
        // if (JSON.stringify(newValue) != JSON.stringify(this.value))
        //   this.show = true;
        // else this.show = false;
      }
    }
  },
  watch: {
    value (newValue) {
      if (JSON.stringify(newValue) != JSON.stringify(this.days)) { this.show = true } else this.show = false
    }
  },
  methods: {
    ...mapActions(['updateCoach']),
    save () {
      this.updateCoach({ disponibility: this.value })
      this.show = false
    }
  }
  // watch: {
  //   "user.coach.disponibility": function(newValue) {
  //     console.log(this.old);
  //     if (newValue.length != this.old) this.show = true;
  //     else this.show = false;
  //   }
  // }
}
</script>
